import Vue from "vue";
import VueRouter from "vue-router";

import AuthGuard from "../Authgaurd";
import HomeGuard from "../HomeGuard";
// import HomeGuard from '../HomeGuard';
import store from "../store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    beforeEnter: HomeGuard,
    component: () =>
      import(/* webpackChunkName: "home" */ "../components/SchoolDashboard.vue")
  },
  {
    path: "/register",
    name: "Register",
    component: () =>
      import(/* webpackChunkName: "register" */ "../components/Register.vue"),
    meta: {
      layout: "auth"
    }
  },
  {
    path: "/room/roll-call",
    name: "RollCallOld",
    beforeEnter: AuthGuard,
    component: () =>
      import(/* webpackChunkName: "roll-call" */ "../components/RollCall.vue")
  },
  {
    path: "/room/dev-form",
    name: "RoomDevelopmentForm",
    beforeEnter: AuthGuard,
    component: () =>
      import(
        /* webpackChunkName: "room-dev-form" */ "../components/RoomDevelopmentForm.vue"
      )
  },
  {
    path: "/student/dev-form",
    name: "DevelopmentForm",
    beforeEnter: AuthGuard,
    component: () =>
      import(
        /* webpackChunkName: "dev-form" */ "../components/DevelopmentForm.vue"
      )
  },
  {
    path: "/holidays/:schoolYearId",
    name: "Holidays",
    props: true,
    beforeEnter: AuthGuard,
    component: () =>
      import(/* webpackChunkName: "holidays" */ "../components/Holidays.vue")
  },
  {
    path: "/students",
    name: "Students",
    props: true,
    beforeEnter: AuthGuard,
    component: () =>
      import(/* webpackChunkName: "students" */ "../components/Students.vue")
  },
  {
    path: "/students/:studentId/profile",
    name: "StudentProfile",
    props: true,
    beforeEnter: AuthGuard,
    component: () =>
      import(
        /* webpackChunkName: "profile" */ "../components/StudentProfile.vue"
      )
  },
  {
    path: "/students/:studentId/info",
    name: "StudentInfo",
    props: true,
    beforeEnter: AuthGuard,
    component: () =>
      import(
        /* webpackChunkName: "student-information" */ "../components/StudentInformation.vue"
      )
  },
  {
    path: "/students/:studentId/report",
    name: "StudentReport",
    props: true,
    beforeEnter: AuthGuard,
    component: () =>
      import(
        /* webpackChunkName: "student-report" */ "../components/StudentAttributeReport.vue"
      )
  },
  {
    path: "/classroom/:classroomId/report",
    name: "ClassroomReport",
    props: true,
    beforeEnter: AuthGuard,
    component: () =>
      import(
        /* webpackChunkName: "classroom-report" */ "../components/ClassroomReport.vue"
      )
  },
  {
    path: "/classroom/:classroomId/upgrade",
    name: "ClassroomUpgrade",
    props: true,
    beforeEnter: AuthGuard,
    component: () =>
      import(
        /* webpackChunkName: "classroom-report" */ "../components/UpgradeStudyClass.vue"
      )
  },
  {
    path: "/classroom/:classroomId/grade/confirm",
    name: "ClassroomConfirmGrade",
    props: true,
    beforeEnter: AuthGuard,
    component: () =>
      import(
        /* webpackChunkName: "classroom-confirm-grade" */ "../components/ClassroomConfirmGrade.vue"
      )
  },
  {
    path: "/student/:studentId/print/:schoolYearId",
    name: "StudentReportPrint",
    props: true,
    beforeEnter: (to, from, next) => {
      AuthGuard(to, from, next);
      store.dispatch("toggleMenu", false);
    },
    meta: {
      layout: "print"
    },
    component: () =>
      import(
        /* webpackChunkName: "student-report-print" */ "../components/StudentReportPrint.vue"
      )
  },
  {
    path: "/classroom/:classroomId/print/:schoolYearId",
    name: "ClassroomReportPrint",
    props: true,
    beforeEnter: (to, from, next) => {
      AuthGuard(to, from, next);
      store.dispatch("toggleMenu", false);
    },
    meta: {
      layout: "print"
    },
    component: () =>
      import(
        /* webpackChunkName: "classroom-report-print" */ "../components/ClassroomReportPrint.vue"
      )
  },
  {
    path: "/print/development-form/:studyClass",
    name: "DevelopmentTemplatePrint",
    props: true,
    beforeEnter: (to, from, next) => {
      AuthGuard(to, from, next);
      store.dispatch("toggleMenu", false);
    },
    meta: {
      layout: "print"
    },
    component: () =>
      import(
        /* webpackChunkName: "classroom-report-print" */ "../components/DevelopmentTemplatePrint.vue"
      )
  },
  {
    path: "/students/:studentId/health",
    name: "StudentHealth",
    props: true,
    beforeEnter: AuthGuard,
    component: () =>
      import(/* webpackChunkName: "health" */ "../components/StudentHealth.vue")
  },
  {
    path: "/classroom/:classroomId",
    name: "Classroom",
    props: true,
    beforeEnter: AuthGuard,
    component: () =>
      import(/* webpackChunkName: "room" */ "../components/Classroom.vue")
  },
  {
    path: "/create/development-form",
    name: "CreateDevelopmentForm",
    beforeEnter: AuthGuard,
    component: () =>
      import(
        /* webpackChunkName: "create-dev-form" */ "../components/CreateDevelopmentForm.vue"
      )
  },
  {
    path: "/login",
    name: "Login",
    component: () =>
      import(/* webpackChunkName: "log-in" */ "../components/Login.vue"),
    meta: {
      layout: "auth"
    }
  },
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    component: () =>
      import(
        /* webpackChunkName: "forgot-password" */ "../components/ForgotPassword.vue"
      ),
    meta: {
      layout: "auth"
    }
  },
  {
    path: "/classrooms",
    name: "Classrooms",
    beforeEnter: AuthGuard,
    component: () =>
      import(
        /* webpackChunkName: "classrooms" */ "../components/Classrooms.vue"
      )
  },
  {
    path: "/users",
    name: "Users",
    beforeEnter: AuthGuard,
    component: () =>
      import(/* webpackChunkName: "users" */ "../components/Users.vue")
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    beforeEnter: AuthGuard,
    component: () =>
      import(
        /* webpackChunkName: "dashboard" */ "../components/AdminDashboard.vue"
      )
  },
  {
    path: "/teacher-dashboard",
    name: "TeacherDashboard",
    beforeEnter: AuthGuard,
    component: () =>
      import(
        /* webpackChunkName: "teacher-dashboard" */ "../components/TeacherDashboard.vue"
      )
  },
  {
    path: "/terms",
    name: "TermSettings",
    beforeEnter: AuthGuard,
    component: () =>
      import(
        /* webpackChunkName: "term-settings" */ "../components/TermSettings.vue"
      )
  },
  {
    path: "/settings",
    name: "SchoolSettings",
    beforeEnter: AuthGuard,
    component: () =>
      import(
        /* webpackChunkName: "school-settings" */ "../components/SchoolSettings.vue"
      )
  },
  {
    path: "/evaluate/student/:studentId",
    name: "EvaluateStudent",
    props: true,
    beforeEnter: AuthGuard,
    component: () =>
      import(
        /* webpackChunkName: "evaluate-student" */ "../components/EvaluateStudent.vue"
      )
  },
  {
    path: "/evaluate/classroom/:classroomId",
    name: "EvaluateClassroom",
    props: true,
    beforeEnter: AuthGuard,
    component: () =>
      import(
        /* webpackChunkName: "evaluate-classroom" */ "../components/EvaluateClassroom.vue"
      )
  },
  {
    path: "/bodymass/classroom/:classroomId",
    name: "BodyMassClassroom",
    props: true,
    beforeEnter: AuthGuard,
    component: () =>
      import(
        /* webpackChunkName: "bodymass-classroom" */ "../components/BodyMassClassroom.vue"
      )
  },
  {
    path: "/dental/classroom/:classroomId",
    name: "DentalClassroom",
    props: true,
    beforeEnter: AuthGuard,
    component: () =>
      import(
        /* webpackChunkName: "dental-classroom" */ "../components/DentalClassroom.vue"
      )
  },
  {
    path: "/rollcall/classroom/:classroomId",
    name: "RollCall",
    props: true,
    beforeEnter: AuthGuard,
    component: () =>
      import(/* webpackChunkName: "roll-call" */ "../components/RollCall.vue")
  },
  {
    path: "/sighthearing/classroom/:classroomId",
    name: "SightHearingClassroom",
    props: true,
    beforeEnter: AuthGuard,
    component: () =>
      import(
        /* webpackChunkName: "sighthearing-classroom" */ "../components/SightHearingClassroom.vue"
      )
  },
  {
    path: "/fileupload",
    name: "ImportStudents",
    beforeEnter: AuthGuard,
    component: () =>
      import(
        /* webpackChunkName: "file-upload" */ "../components/ImportStudents.vue"
      )
  },
  {
    path: "/import/crews",
    name: "ImportStudents",
    beforeEnter: AuthGuard,
    component: () =>
      import(
        /* webpackChunkName: "import-crews" */ "../components/ImportCrews.vue"
      )
  },
  {
    path: "/manage/classrooms",
    name: "ClassroomsManage",
    beforeEnter: AuthGuard,
    component: () =>
      import(
        /* webpackChunkName: "classrooms-manage" */ "../components/ClassroomsManage.vue"
      )
  },
  {
    path: "/new/students",
    name: "NewStudents",
    beforeEnter: AuthGuard,
    component: () =>
      import(
        /* webpackChunkName: "new-student" */ "../components/NewStudents.vue"
      )
  },
  {
    path: "/classroom/:classroomId/comment",
    name: "ClassroomComment",
    props: true,
    beforeEnter: AuthGuard,
    component: () =>
      import(
        /* webpackChunkName: "classroom-comment" */ "../components/ClassroomComment.vue"
      )
  },
  {
    path: "/classroom/:classroomId/summary-print/:schoolYearId",
    name: "SummaryClassroomPrint",
    props: true,
    beforeEnter: AuthGuard,
    meta: {
      layout: "print"
    },
    component: () =>
      import(
        /* webpackChunkName: "classroom-comment" */ "../components/SummaryClassroomPrint.vue"
      )
  },
  {
    path: "/reports/:selectedId?",
    name: "ClassroomsReport",
    beforeEnter: AuthGuard,
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "reports" */ "../components/ClassroomsReport.vue"
      )
  },
  {
    path: "/school-dashboard",
    name: "SchoolDashboard",
    beforeEnter: AuthGuard,
    component: () =>
      import(
        /* webpackChunkName: "school-dashbaord" */ "../components/SchoolDashboard.vue"
      )
  }
];

//SummaryClassroomPrint

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
